import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { ItemCard, Grid, Button, Tabs, Typography, Skeleton, Dialog, TemplateCard } from "../../../../";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { FormControlLabel, Divider, FormControl, Input, InputAdornment } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    tagList: {
      display: "flex",
      "flex-direction": "column"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    },
    margin: {
      "margin-bottom": "20px",
      width: "50%"
    }
  };
});

var Templates = function Templates(props) {
  var templates = props.templates,
      translation = props.translation;

  var _useState = useState("event"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState({
    event: false,
    campus: false,
    academy: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      categories = _useState4[0],
      setCategories = _useState4[1]; // const [tags, setTags] = useState({});


  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      id = _useState8[0],
      setId = _useState8[1];

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var classes = useStyles();

  var handleChange = function handleChange(name, type) {
    return function (event) {
      setCategories(_objectSpread(_objectSpread({}, categories), {}, _defineProperty({}, name, event.target.checked))); // type === "category"
      //   ? setCategories({ ...categories, [name]: event.target.checked })
      //   : setTags({ ...tags, [name]: event.target.checked });
    };
  };

  var handleSearchChange = function handleSearchChange(event) {
    // console.log("event", event.target.value);
    setSearch(event.target.value);
  }; // const createTagList = templates => {
  //   const _tags = {};
  //   _.flatten(
  //     _.uniq(templates && templates.map(template => template.tags))
  //   ).forEach(tag => (_tags[tag] = false));
  //   return _tags;
  // };
  // useEffect(() => {
  //   setTags(createTagList(templates));
  // }, [templates]);


  var createFilteredTemplates = function createFilteredTemplates() {
    var auxTemplates = props.templates;

    if (Object.keys(categories).filter(function (el) {
      return categories[el];
    }).length > 0) {
      // console.log("categories filter activated", categories);
      var _categories = Object.keys(categories).filter(function (el) {
        return categories[el];
      });

      auxTemplates = auxTemplates.filter(function (template) {
        return _categories.includes(template.type);
      });
    } // if (Object.keys(tags).filter(el => tags[el]).length > 0) {
    //   // console.log("tags filter activated", tags);
    //   const _tags = Object.keys(tags).filter(el => tags[el]);
    //   auxTemplates = auxTemplates.filter(
    //     template => _.intersection(template.tags, _tags).length > 0
    //   );
    // }


    if (search !== "") {
      auxTemplates = auxTemplates.filter(function (template) {
        return template.name.toLowerCase().includes(search.toLowerCase()) || template.description.toLowerCase().includes(search.toLowerCase());
      });
    }

    return auxTemplates;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Templates"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: props.handleAddTemplate
  }, "+ Add Template")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    md: 2,
    className: classes.tagList
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filterByCategory : "Filter by category"), categories && Object.keys(categories).map(function (category) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: categories[category],
        onChange: handleChange(category, "category"),
        value: category,
        color: "primary"
      }),
      label: category.toUpperCase()
    });
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10,
    md: 10
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.margin
  }, /*#__PURE__*/React.createElement(Input, {
    name: "search",
    value: search,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(SearchIcon, null)),
    fullWidth: true,
    onChange: handleSearchChange
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, createFilteredTemplates().map(function (template, i) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 4
    }, /*#__PURE__*/React.createElement(TemplateCard, Object.assign({}, template, {
      baseUrl: "/templates/"
    })));
  }))));
};

export default Templates;